import { useRouter } from "lib/router";
import React from "react";
import { canSendPageView } from "utils/gtm";
import { pathnameToPageType } from "utils/pathnameToPageType";
import { useSegment } from "./useSegment";

type Props = {
  isOos?: boolean;
  productIds?: string[];
  eventId?: string;
};

const removeTokenFromUrl = (url: string): string => {
  const urlParams = new URL(url);
  urlParams.searchParams.delete("token");
  return urlParams.toString();
};

export const useSegmentPage = ({ isOos, productIds, eventId }: Props): void => {
  const { page } = useSegment();
  const { asPath, pathname, query } = useRouter();

  const cmsPathnameToPageType = (pathName: string): string => {
    const name = pathName.split("/")[2];
    const newName = name
      ?.split(" ")
      ?.map((word) => (word[0] ?? "").toUpperCase() + word.substring(1))
      ?.join(" ");
    return newName ?? "";
  };

  React.useEffect(() => {
    const { refresh } = query;
    const { referrer } = document;

    if (refresh) return;
    // TODO: remove this check when fully migrated to the new platform from HCL
    const isPageView = canSendPageView(asPath, pathname, false);
    const isCmsPage = asPath.startsWith("/bp");

    if (isPageView || isCmsPage) {
      const pageName = isCmsPage
        ? cmsPathnameToPageType(asPath)
        : pathnameToPageType(asPath);
      if (pageName === undefined) return;

      page(
        {
          name: pageName,
          properties: {
            title: document.title,
            url: removeTokenFromUrl(window.location.href),
            path: window.location.pathname,
            referrer: referrer === "" ? undefined : referrer,
            search:
              window.location.search === ""
                ? undefined
                : window.location.search,
            is_oos: isOos,
            product_ids: productIds
          }
        },
        { event_id: eventId }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asPath, pathname]);
};
